import LocalStorage from "../LocalStorage";
import {isDefined} from "../../../utils/Utils";

/**
 * Asset categories list filters
 */
export class AssetCategoriesListFilter {
	constructor(public hideDisabledAssetCategories: boolean) {}

	static empty(): AssetCategoriesListFilter {
		return new AssetCategoriesListFilter(false);
	}

	/**
	 * Parse local storage data.
	 * @param data data to parse.
	 * @returns {AssetCategoriesListFilter}
	 */
	static getFromLocalStorageData(data: any): AssetCategoriesListFilter {
		if (!isDefined(data)) {
			return AssetCategoriesListFilter.empty();
		}
		return new AssetCategoriesListFilter(data.hideDisabledAssetCategories);
	}

	updateDisabledAssetCategories(value: boolean): AssetCategoriesListFilter {
		this.hideDisabledAssetCategories = value;
		LocalStorage.saveAssetCategoriesListFilters(this);
		return this;
	}
}
